import { keyLabels } from '@/copy'
import { cx } from '../cx'
import styles from './Kbd.module.css'

type Modifier = keyof typeof keyLabels.apple
type Common = keyof typeof keyLabels.common

const isModifier = (key: string): key is Modifier => key in keyLabels.apple
const isCommon = (key: string): key is Common => key in keyLabels.common

export function Kbd({
  keys,
  className,
}: {
  keys: readonly string[]
  className?: string
}) {
  const apple =
    typeof navigator !== 'undefined' &&
    /mac|iphone|ipad|ipod/i.test(
      (navigator as Navigator & { userAgentData?: { platform?: string } })
        .userAgentData?.platform ?? navigator.platform,
    )

  function label(key: string): string {
    if (isModifier(key)) return keyLabels[apple ? 'apple' : 'other'][key]
    if (isCommon(key)) return keyLabels.common[key]
    return key.length === 1 ? key.toUpperCase() : key
  }

  // Key ids count repeats of the same key instead of using the array index.
  const seen = new Map<string, number>()
  const caps = keys.map((k) => {
    const n = seen.get(k) ?? 0
    seen.set(k, n + 1)
    return { id: `${k}-${n}`, text: label(k) }
  })

  return (
    <kbd className={cx(styles.chord, className)}>
      {caps.map(({ id, text }) => (
        <kbd key={id} className={styles.key}>
          {text}
        </kbd>
      ))}
    </kbd>
  )
}
